/* eslint-disable react/display-name */

import React, { useEffect, memo, useState } from 'react';

import cx from 'classnames';

import { useDispatch, useSelector } from 'react-redux';
import { locationActions } from '../../redux/actions';

import styles from './Assignments.module.scss';

import { Device } from '../../components/Devices';
import { CustomDataTable } from '../../components/Datatable';

import useUser from '@/lib/hooks/useUser';
import { useGetLocationsQuery } from 'services/locations';

const headers = [
  {
    id: 'name',
    title: 'Standort',
    sortCycle: 'bi-states-from-ascending',
  },
  {
    id: 'city',
    title: 'Stadt',
    sortCycle: 'tri-states-from-ascending',
  },
  {
    id: 'organisation',
    title: 'Betreiber',
  },
];

const getRowItems = (rows, isAdmin = false) => {
  return rows.map((row) => {
    let a = {
      id: row.model.ID,
      name: row.name,
      city: row.address.city,
      devices: row.devices || [],
    };

    if (isAdmin) {
      a.organisation = row.organisation ? row.organisation.name : null;
    }

    return a;
  });
};

const AssignmentsRowDetails = memo(
  ({
    isVisible = false,
    item,
    onClickInsideExpandedRow = () => {},
    innerSelections = [],
  }) => {
    if (isVisible === false) {
      return <div></div>;
    }
    return (
      <div className={cx(styles.content)}>
        <div style={{ width: '100%', float: 'left' }}>
          {(item.devices || []).map((d) => (
            <Device
              expanded={false}
              device={d}
              key={`location_${item.id}_device_${d.model.ID}`}
              onClick={() => onClickInsideExpandedRow(d.model.ID)}
              selected={innerSelections.includes(d.model.ID) || false}
            />
          ))}
        </div>
      </div>
    );
  }
);

const Assignments = memo(
  ({
    assignments = [],
    onAssignmentsChanges = () => {},
  }) => {

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const [rows, setRows] = useState([]);
    const [sortBy, setSortBy] = useState({
      sortId: 'locations.name',
      columnId: 'name',
      direction: 'DESC',
    });

    const [query, setQuery] = useState({pageIndex: page, order_by: sortBy, pageSize: pageSize});
    const {
      data = {data: {records: [], total_record: 0}},
      isFetching,
    } = useGetLocationsQuery(query, {refetchOnMountOrArgChange: false});


    const { isAdmin } = useUser();

    //const { owner_items } = useSelector((state) =>
    //  (state.organisation.items || []).map((i) => ({
    //    id: i.model.ID,
    //    text: i.name,
    //  }))
    //);
    //const onChangeOwner = (i) => {
    //  console.info(i);
    //};

    /*useEffect(() => {
      dispatch(
        locationActions.getAll({
          pageSize: pageSize,
          pageIndex: page,
        })
      );
    }, [page, pageSize, dispatch]);*/

    useEffect(() => {
      if (sortBy && sortBy.length > 0) {
        const a = sortBy[0].split(' ');
        setSortBy({ sortId: a[0], direction: a[1] || 'ASC' });
      }
    }, [sortBy]);

    useEffect(() => {
      if (data.data.records && data.data.records.length > 0) {
        setRows(getRowItems(data.data.records || [], [], isAdmin, /*rows*/));
      }
    }, [data, isAdmin]);

    //{ filters, sortBy, pageSize, pageIndex, search = '' }
    /*const handleLoadItems = ({
      sortBy,
      pageSize,
      pageIndex,
    }) => {
      dispatch(
        locationActions.getAll({
          pageSize: pageSize,
          pageIndex: pageIndex,
          sortBy: sortBy,
        })
      );
    };*/

    const onClickDevice = (device_id) => {
      let n = assignments.includes(device_id)
        ? assignments.filter((i) => i !== device_id)
        : [...assignments, device_id];
      onAssignmentsChanges(n);
    };

    return (
      <>
        <CustomDataTable
          columns={headers.slice(
            0,
            isAdmin ? headers.length : headers.length - 1
          )}
          rows={rows}
          sortInfo={sortBy}
          loadItems={({
            pageSize: newPageSize,
            pageIndex: newPageIndex,
            sortBy: newSortBy,
          }) => {
            //if (newPageSize !== pageSize) {
            //  setPageSize(newPageSize);
            //}

            //if (newPageIndex !== page) {
            //console.info("LAODDDDDD:", newPageSize, page, newPageIndex, newSortBy);
            //setPage(newPageIndex);

            setPage(newPageIndex);
            setQuery(f => { return {...f, pageIndex: newPageIndex, sortBy: newSortBy, pageSize: newPageSize}});
            //}
            if (newSortBy !== sortBy && newSortBy !== undefined) {
              setSortBy(newSortBy);
            }

          }}
          totalItems={data.data.total_record}
          pageSize={pageSize}
          page={page}
          hasExpandedRow={true}
          onClickInsideExpandedRow={onClickDevice}
          expandedRowComponent={AssignmentsRowDetails}
          innerSelections={assignments}
          isLoading={isFetching}
        />
      </>
    );
  }
);

export default Assignments;
